import { render, staticRenderFns } from "./projectPhoto.vue?vue&type=template&id=2a451c1a&scoped=true&"
import script from "./projectPhoto.vue?vue&type=script&lang=js&"
export * from "./projectPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a451c1a",
  null
  
)

export default component.exports